<template>
    <div class="help-center-content">
        <h4>了解平台</h4>
        <p class="title">1.  作品有声化平台是什么？</p>
        <p class="content">
            喜马拉雅作品有声化平台<br>
            是作者、出版机构可将自己作品有声化的平台<br>
            也是主播挑选自己喜欢的书籍、文章，发挥特质完成录音制作的平台<br>
            同时，后期制作者可在平台找到优质有声化成品，加以后期制作，让作品熠熠生辉<br>
            最终，三方完成的成品可以在4亿用户的喜马拉雅平台上与用户见面，共享流量与收益<br><br>
            如果你手中有书，找不到专业的声音录播团队<br>
            如果你有一副好嗓子，却难以找到梦寐以求的主播成长平台<br>
            如果你有一身后期制作本领，确没有优质作品让你大显身手<br>
            喜马拉雅作品有声化平台<br>
            恰好可以给你想要的<br>
            为你提供成长机会，更给你一个多彩的舞台<br>
        </p>
        <p class="title">2.  我能在作品有声化平台做些什么？</p>
        <p class="content">在这里，你可以：</p>
        <img :src="`${IMG_HOST}copyrightHelpCenter/img_1.png`"  style="width: 490px;height: 119px;">
        <p class="title">3.  我能在作品有声化平台收获什么？</p>
        <p class="content">通过作品有声化平台，你能持续获得收益，包括有声作品销售分成以及平台广告收入分成。喜马拉雅FM拥有4亿用户，依托巨大的流量红利，你的纸书、电子书和周边产品等也能一同获利。<br>
            除了收益外，为你演绎有声作品的平台优秀主播，拥有大量的粉丝和专业的播讲实力，能够帮助你收获更多人气和影响力。
        </p>
        <p class="title">4.  作品有声化平台使用流程</p>
        <p class="content">Step  1：<router-link :to="{name: 'helpCenterCopyrighterSignIn'}">入驻平台</router-link><br>
            注册账号，填写个人或机构资料，提交审核。审核通过即代表入驻成功。<br>
            Step  2 : <router-link :to="{name: 'helpCenterCopyrightManagement'}">上传作品</router-link><br>
            入驻成功后，进入版权工作台，填写作品信息，并上传作品内容文本。<br>
            Step  3：<router-link :to="{name: 'helpCenterTaskManagement'}">发布任务</router-link><br>
            当提交作品审核通过后，就可以发布海选任务，招募并选拔主播。
        </p>
        <p class="title">5.  平台联系方式</p>
        <p class="content">
            <strong>有声化平台官方邮箱：a.plus@ximalaya.com。</strong><br>
            有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务
        </p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// CopyrighterAboutPlatform.vue?84c6f90e